"use strict";

module.exports = /*@ngInject*/function ($location) {
  var ctrl = this;
  var params = $location.search();
  ctrl.statusCode = params.statusCode;
  ctrl.message = params.message || 'An error occurred';
};